import { observer } from 'mobx-react'
import orderBy from 'lodash/orderBy'

import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { ColumnFilterProps } from '@new/domains/operations/screens/CasesV2/CasesV2.types'
import { casesFilterOptionsStore } from '@new/domains/operations/screens/CasesV2/stores/CasesFilterOptionsStore'
import { casesFiltersStore } from '@new/domains/operations/screens/CasesV2/stores/CasesFiltersStore'
import { CaseFilterIds } from '@new/domains/operations/screens/CasesV2/utils/config'

import * as S from './commonFilterStyles.style'

const _CaseVendorsFilter = (props: ColumnFilterProps) => {
  const { vendorsInSelectedRegions, isLoadingCaseVendors } = casesFilterOptionsStore
  const { caseVendors, setFilterValue } = casesFiltersStore

  const handleDataFilter = (value?: string[]) => {
    setFilterValue(CaseFilterIds.CaseVendor, value)
  }

  const filterOptions = [
    {
      value: '00000000-0000-0000-0000-000000000000',
      label: 'N/A',
      minWidth: 100,
    },
    ...(orderBy(vendorsInSelectedRegions?.map(user => ({
      value: user.id,
      label: user.name.trim(),
      minWidth: 100,
    })) ?? [], 'label')),
  ]

  return (
    <S.CheckBoxWrapper>
      <CheckboxBasedFilter
        title="Case Vendors"
        options={filterOptions}
        isLoadingOptions={isLoadingCaseVendors}
        initialValue={caseVendors}
        onChange={handleDataFilter}
        {...props}
      />
    </S.CheckBoxWrapper>
  )
}

export const CaseVendorsFilter = observer(_CaseVendorsFilter)
